var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tabs',{attrs:{"background-color":"light-primary","active-class":"mid-primary","color":"transparent"},model:{value:(_vm.tabs),callback:function ($$v) {_vm.tabs=$$v},expression:"tabs"}},[_vm._l((_vm.tabsArray),function(ele,index){return _c('div',{key:index},[_c('v-tab',{staticClass:"white--text",attrs:{"to":{
					name: ele.pageName,
					query: { employeeId: _vm.$route.query.employeeId, name: _vm.$route.query.name },
				}}},[_vm._v(" "+_vm._s(ele.title)+" ")])],1)}),_c('v-tab',{staticClass:"white--text",attrs:{"to":{
				name: 'interview-ranking',
				query: { employeeId: _vm.$route.query.employeeId, name: _vm.$route.query.name },
			}}},[_vm._v(" "+_vm._s(_vm.$T('tabs.interviewRanking'))+" ")]),_c('v-tab',{staticClass:"white--text",attrs:{"to":{
				name: 'employee-performance',
				query: { employeeId: _vm.$route.query.employeeId, name: _vm.$route.query.name },
			}}},[_vm._v(" "+_vm._s(_vm.$T('tabs.employeePerformance'))+" ")]),_c('v-tab',{staticClass:"white--text",attrs:{"to":{
				name: 'evaluate-performance-during-the-experiment',
				query: { employeeId: _vm.$route.query.employeeId, name: _vm.$route.query.name },
			}}},[_vm._v(" تقييم أداء موظف فني ")]),_c('v-tab',{staticClass:"white--text",attrs:{"to":{
				name: 'technical-performance',
				query: { employeeId: _vm.$route.query.employeeId, name: _vm.$route.query.name },
			}}},[_vm._v(" تقييم أداء موظف من خلال التجربة ")]),_c('v-tab',{staticClass:"white--text",attrs:{"to":{
				name: 'job-satisfaction-questionnaire',
				query: { employeeId: _vm.$route.query.employeeId, name: _vm.$route.query.name },
			}}},[_vm._v(" استبيان رضا وظيفي ")])],2),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }